'use strict'
// this exists so we can replace it during testing
module.exports = setInterval



//////////////////
// WEBPACK FOOTER
// ./~/fsevents/~/gauge/set-interval.js
// module id = 2870
// module chunks = 0